/**
* jv.candidate.details.workflow.offerLetter.controller Module
*
* Description
*/
angular.module('jv.candidate.details.workflow.offerLetter.controller', [])
    .controller('jvCandidateDetailsWorkflowOfferLetterController', ['$scope', '$routeParams', 'candidates', '$location', '$rootScope','jvFormFieldDropDownValuesFAC','$window', 'jvHireUrlService',
        function($scope, $routeParams, candidates, $location, $rootScope, jvFormFieldDropDownValuesFAC, $window, jvHireUrlService){
            $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
            $scope.offerLetterFields = jvFormFieldDropDownValuesFAC;
            $scope.disableSaveButton = false;
            $scope.disableNextButton = false;

            $scope.offer = JSON.parse($window.localStorage.getItem('offerDetails'));

            var initializeReqFields = function(){
                $scope.requiredFields = {
                    Job: [],
                    Candidate: []
                };
            };

            var processOfferForm = function(res){
                initializeReqFields();
                $scope.offer.approvalEnabled = res.offerForm.model.approvalEnabled;
                $scope.offer.hasUnresolvedReqFields = false;
                            
                if($scope.offer.editMode){
                    $scope.offer.canEditApplicationDetails = res.offerForm.model.canEditApplicationDetails;
                    $scope.offer.canEditRequisitionDetails = res.offerForm.model.canEditRequisitionDetails;
                }
                
                $scope.offer.currencyMap = res.currencyMap;
                if(res && res.offerForm && res.offerForm.model) {
                    var hasFormAccess= res.offerForm.model.hasWriteAccessOnAllMandatoryField;
                    var hasFormViewAccess=res.offerForm.model.viewOnlyOffer;
                    $scope.offer.viewEnabled=angular.isUndefined(hasFormViewAccess) ? false : hasFormViewAccess;
                    $scope.offer.submitEnabled = angular.isUndefined(hasFormAccess) ? false : hasFormAccess;
                }
                if (res && res.offerForm && res.offerForm.workflowElementInfo && res.offerForm.workflowElementInfo.elementName) {
                    $scope.workflowLabel = res.offerForm.workflowElementInfo.elementName;
                }
                $scope.offer.candOfferViewFields = [];
                $scope.offerFieldsBackUp = [];
                if(res.offerForm.model.viewFields)
                {
                    $scope.offer.candOfferViewFields.push(res.offerForm.model.viewFields);
                    var viewFieldsBackUp = res.offerForm.model.viewFields.map(function(viewField) {
                        return {
                            triggersApproval: viewField.triggersApproval,
                            value: viewField.value,
                            readOnly: viewField.readOnly
                        };
                    });
                    $scope.offerFieldsBackUp.push(viewFieldsBackUp);
                }
                else if(res.offerForm.model.candidateFields || res.offerForm.model.requisitionFields)
                {
                    $scope.offer.candOfferViewFields.push(res.offerForm.model.candidateFields);
                    $scope.offer.candOfferViewFields.push(res.offerForm.model.requisitionFields);
                    var candidateFieldsBackUp = res.offerForm.model.candidateFields.map(function(viewField) {
                        return {
                            triggersApproval: viewField.triggersApproval,
                            value: viewField.value,
                            readOnly: viewField.readOnly
                        };
                    });
                    var requisitionFieldsBackUp = res.offerForm.model.requisitionFields.map(function(viewField) {
                        return {
                            triggersApproval: viewField.triggersApproval,
                            value: viewField.value,
                            readOnly: viewField.readOnly
                        };
                    });
                    $scope.offerFieldsBackUp.push(candidateFieldsBackUp);
                    $scope.offerFieldsBackUp.push(requisitionFieldsBackUp);
                }
                angular.forEach($scope.offer.candOfferViewFields[0], function(field) {
                    if(field.fieldType === 'Currency' && !field.isReadOnly) {
                        field.value = {
                            currencyCode : field.unitOfMeasure,
                            value: angular.copy(field.value)
                        };
                    }
                });
            };
            
            var setSelectedOffer = function(offers, offer) {
                if (offers) {
                    for(var i = 0; i < offers.length; i++) {
                        if (offers[i].eid === offer.offerForm.model.offerFormEId) {
                            $scope.offer.selectedOffer = offers[i];
                            break;
                        }
                    }
                }
            };

            var getActiveOffers = function(offers) {
                var activeForms = [];
                if (offers) {
                    for(var i = 0; i < offers.length; i++) {
                        if (offers[i].status === 'Active') {
                            activeForms.push(offers[i]);
                        }
                    }
                }
                return activeForms;
            };
            // flag to check if any form on the page is in edit mode
            $scope.$on('isFormEditInProgessEvt', function() {
                $rootScope.isFormEditInProgress = $scope.offer ? $scope.offer.editMode : true;
            });

            $scope.$on('$routeChangeStart', function () {

                    if ($window.localStorage.getItem('offerDetails')) {
                        $scope.offerEdit = JSON.parse($window.localStorage.getItem('offerDetails'));
                    }else{
                        $scope.offerEdit = {};
                    }

                    $scope.offerEdit.editMode = false;
                    $scope.offerEdit.createMode = false;
                    $window.localStorage.setItem('offerDetails', JSON.stringify($scope.offerEdit));
            });

            var viewCandidateOfferForm = function(data){
                var workflowSteps = $scope.appDetails.applicationWorkflowSteps;
                for(var i = 0; i < workflowSteps.length; i++) {
                    var workflowStep = workflowSteps[i];

                    if (workflowStep.workflowElementInfo && workflowStep.workflowElementInfo.EId === data.stateId) {
                        $scope.workflowLabel = workflowStep.workflowElementInfo.elementName;
                        break;
                    }
                }

                if($scope.offer.multipleOfferFormsEnabled){
                    candidates.getOfferForms($routeParams.applicationId, function(offers) {
                        var offerForms = offers.offerForms;
                        var activeOffers = getActiveOffers(offerForms);
                        if (offerForms && activeOffers.length === 1) {
                            data.eId = activeOffers[0].eid;
                        }

                        candidates.candOfferForm(data, function(offer){
                            if (offer.offerForm.model.offerFormEId) {
                                setSelectedOffer(offerForms, offer);
                                processOfferForm(offer);
                            }
                        });
                    });
                } else {
                    candidates.candOfferForm(data, function(offer){
                        processOfferForm(offer);
                    });
                }
            };

            
            if($location.$$path.search('workflow-offerLetter') !== -1){
                if(!$scope.offer){
                    if ($window.localStorage.getItem('offerDetails')) {
                        $scope.offer = JSON.parse($window.localStorage.getItem('offerDetails'));
                        $window.localStorage.removeItem('offerDetails');
                    } else {
                        $scope.offer = {};
                        $scope.offer.editMode = false;
                        $scope.offer.error = false;
                    }
                }
                $scope.offer.selectedOffer = {};
                $scope.offer.submitEnabled = true;
                $scope.offer.multipleOfferFormsEnabled = false;
                candidates.userCanEditOfferForm($routeParams.applicationId, function(res){
                    if(res.userCanEditOfferForm){
                        $scope.canEditOffer = true;
                        return;
                    }
                });
                if(window.location.search.indexOf('edit=true') > -1){
                    $scope.offer.editMode = true;
                }
                if(window.location.search.indexOf('offerFormEId=') > -1){
                    $scope.offer.eId = $scope.urlParams()['offerFormEId'];
                }

                $scope.flags.loading = true;
                var data = {};
                data.id = $routeParams.applicationId;
                data.edit = $scope.offer.editMode;
                data.stateId = $routeParams.stateId;
                data.multipleOfferFormsEnabled = $scope.offer.multipleOfferFormsEnabled;
                data.eId = $scope.offer.eId;

                candidates.getMultipleOfferFormsFlag(function(res) {
                    $scope.offer.multipleOfferFormsEnabled = data.multipleOfferFormsEnabled = res.hasMultipleOfferFormsEnabled;
                    // eslint-disable-next-line no-undefined
                    $scope.offer.createMode = undefined;
                    viewCandidateOfferForm(data);
                    $scope.flags.loading = false;
                });

                $scope.offer.closeModal = function(){
                    $scope.offer.fillFormFieldModal = false;
                };
            }

            $scope.getEditableOfferForm = function(offerFormEId){
                var data = {};
                data.id = $routeParams.applicationId;
                data.edit = $scope.offer.editMode;
                data.stateId = $routeParams.stateId;
                data.multipleOfferFormsEnabled = $scope.offer.multipleOfferFormsEnabled;
                data.eId = offerFormEId;
                $scope.offer.editMode = data.edit = true;
                $scope.editOffer = true;
                viewCandidateOfferForm(data);
            };

            $scope.getOfferFormFields = function(){
                if ($scope.offer.selectedOffer && $scope.offer.selectedOffer.eid) {
                    var data = {};
                    data.id = $routeParams.applicationId;
                    data.edit = $scope.offer.editMode;
                    data.stateId = $routeParams.stateId;
                    data.multipleOfferFormsEnabled = $scope.offer.multipleOfferFormsEnabled;
                    data.eId = $scope.offer.selectedOffer.eid;
                    candidates.candOfferForm(data, function(res){
                        processOfferForm(res);
                    });
                }
            };

            $scope.cleanFieldValue= function(choiceArray){
            if(choiceArray){
                var cleanedValues=[];
                for(var i=0; i<choiceArray.length; i++){
                    if(choiceArray[i]){
                        cleanedValues.push(choiceArray[i]);
                    }
                }
                return cleanedValues;
            }
            return choiceArray;
            };
            /**
             * Remove watchers in case if they are there in scope to avoid false calls
             */
            if($scope.selectApprovers &&
                    $scope.selectApprovers.offerApprovalInfo &&
                    $scope.selectApprovers.offerApprovalInfo.model &&
                    $scope.selectApprovers.offerApprovalInfo.model.watchUsers
                    ){
                delete $scope.selectApprovers.offerApprovalInfo.model.watchUsers;
            }
            
            $scope.approverMail= {
                evalFormInclude : true
            };

            /**
             * check if user checked any value of check box or not.
             * @param {Object} checkBoxField - checkBoxField object.
             * @returns {Bool} valueChecked - checked value.
             */
            $scope.hasCheckedValues = function(checkBoxField){
                var valueChecked = false;
                if (checkBoxField.values) {
                    for(var i = 0 ; i < checkBoxField.values.length ; i++) {
                        if(checkBoxField.values[i].checked) {
                            valueChecked = true;
                        }
                    }
                }
                
                return valueChecked;
            };

            /**
             * check if value of data is null or empty.
             * @param {Object} data - object of form field.
             * @returns {Bool} emptyOrNullValue - returns Boolean if value of field is null or empty.
             */
            $scope.isEmptyOrNull = function(data){
                var emptyOrNullValue = true;
                switch(data.fieldType){
                    case 'CheckBox':
                    emptyOrNullValue = !$scope.hasCheckedValues(data);
                    break;

                    case 'Currency':
                    emptyOrNullValue = $scope.isNullCurrency(data);
                    break;

                    default :
                    emptyOrNullValue = (!data.value || data.value.length === 0);
                }
                return emptyOrNullValue;
            };



            $scope.getType = function(step){

                var validationError;

                /**
                 * check whether offer form has unresolved field or not. if it has show pop-up to resolve field first.
                 */
                
                if(((step.objectType === 'Job' && $scope.appDetails.application.job.EId)
                        || step.objectType === 'Candidate')
                    && step.required && step.readOnly
                    && (!step.value || !step.value.toString().trim())
                    && (!step.data || (step.data && step.data.length === 0))
                    && $scope.offer.editMode
                    && $scope.requiredFields
                    && $scope.requiredFields[step.objectType]
                    && $scope.requiredFields[step.objectType].indexOf(step) === -1){
                    
                    $scope.requiredFields[step.objectType].push(step);
                    $scope.offer.fillFormFieldModal = true;
                    $scope.offer.hasUnresolvedReqFields = true;
                }

                /**
                 * Validate number, amount, and currency field if it has value.
                 */
                if(step.value
                   && (step.fieldType === 'Number' || step.fieldType === 'Amount' || (step.fieldType === 'Currency' && step.value.value))){
                       validationError = !$scope.hasValidData(step);
                       step.error = step.numberError = validationError;
                }

                if($scope.offer.editMode && step.required && !validationError && !$scope.isEmptyOrNull(step)) {
                    step.error = false;
                }

                return step.fieldType ? step.fieldType : step.objectType;
            };

            var massageWatchers = function(model){
                model.watchUsers = [];
                for(var i in model.watchers){
                    model.watchUsers.push(model.watchers[i].user);
                }
            };

            $scope.$watch('selectApprovers.offerApprovalInfo.model.offerApprovalInfo.selectedHM' , function(newVal){
                if(newVal){
                    $scope.flags.loading=true;
                    var data = {
                        hm : newVal
                    };

                    if($routeParams.mId){
                        data.mId = $routeParams.mId;
                    }

                    candidates.getSelectApproverMessage($routeParams.applicationId, $.param(data, true), function(res){
                        $rootScope.selectApprovers = res;
                        $scope.flags.loading=false;
                        $scope.selectApprovers.offerApprovalInfo.model.offerApprovalInfo.selectedHM = newVal;
                        $scope.selectApproverFunction($rootScope.selectApprovers);
                        massageWatchers($rootScope.selectApprovers.offerApprovalInfo.model);
                    });
                }
            });

            $scope.candNavigate = function(){
                $scope.offer.closeModal();
                jvHireUrlService.loadCandidateDetailsTabByLink('summary/'+$routeParams.applicationId+'/edit');
            };
            
            $scope.reqNavigate = function(){
                $scope.offer.closeModal();
                window.location.href = $scope.jvUrls.jhire+'/modules/requisitions/tabs.html#/details-edit/'+$scope.appDetails.application.job.EId;
            };
            
            $scope.checkBoxFunction = function(step){
                if(step.value instanceof Array){
                    // do nothing
                }else{
                    if(step.value){
                        step.value = step.value.split('\n');
                        if(!step.readOnly && step.values){
                            for(var i = 0 ; i < step.values.length ; i++){
                                step.values[i].checked = false;
                                for(var j = 0 ; j < step.value.length ; j++){
                                    if(step.value[j] === step.values[i].key){
                                        step.values[i].checked = true;
                                    }
                                }
                            }
                        }
                    }
                }
            };

            /**
             * To validate field data of number, currency and amount field.
             * @param {Object} field - object of form field.
             * @returns {Bool} isValidData - return Boolean if value is valid.
             */
            $scope.hasValidData = function(field){
                var isValidData;
                switch(field.fieldType){
                    case 'Number':
                    case 'Amount':
                    isValidData = !$scope.isNumberValid(field.value);
                    break;

                    case 'Currency':
                    if(!$scope.isNullCurrency(field)){
                        isValidData = !$scope.isNumberValid(field.value.value);
                    }
                    break;

                    default:
                    break;

                }
                return isValidData;
            };

            /**
             * Returns Array of empIds from user selected employees.
             * @param {Object} employeeField - object of employee field.
             * @returns {Array} employeeField.emp - list of employee ids.
             */
            $scope.processEmployeeFieldData = function(employeeField){
                employeeField.emp =[];
                if(employeeField.value){
                    for(var i = 0; i < employeeField.value.length; i++){
                        employeeField.emp.push(employeeField.value[i].EId);
                    }
                }
                return employeeField.emp;
            };

            /**
             * Returns array of cheched values from check box field.
             * @param {Object} checkBoxField - check box object.
             * @returns {Array} checkBoxField.value - array of checked values.
             */
            $scope.processCheckBoxFieldData = function(checkBoxField){
                checkBoxField.value = [];
                if(checkBoxField.values){
                    for(var i=0; i < checkBoxField.values.length; i++){
                        if(checkBoxField.values[i].checked){
                            checkBoxField.value.push(checkBoxField.values[i].key);
                        }
                    }
                }
                return checkBoxField.value;
            };

            /**
             * check if currency field has null values and null currency code.
             * @param {Object} currencyField - currency object.
             * @returns {Bool}
             */
            $scope.isNullCurrency = function(currencyField){
                return !(currencyField.value && currencyField.value.currencyCode && currencyField.value.value);
            };

            $scope.processApprovalForm = function(form){
                var data = {};
                var formIsValid = true;
                var numberError = false;
                var currencyError = false;
                var requiredFieldError = false;
                for(var i=0; i<form.length; i++){
                    var obj = form[i];
                    for(var j=0; j<obj.length; j++){
                        var objData = obj[j];

                        // skip all read only fields.
                        if(!objData.readOnly){
                            objData.value = angular.isDefined(objData.value) ? objData.value : '';
                            //if required field value is null or empty then set validation errors.
                            if(objData.required && $scope.isEmptyOrNull(objData)){
                                requiredFieldError = objData.error = true;
                                formIsValid = false;
                                objData.numberError = objData.fieldType === 'Number' || objData.fieldType === 'Amount' ? true : '';
                            } else {
                                /**
                                 * 1. if field is required and it has value then validate value of each fields.
                                 * 2. if field is optional and it has value of invalid data then set validation error.
                                 */
                                switch(objData.fieldType){
    
                                    case 'CheckBox':
                                    data[objData.EId || objData.fieldId] = $scope.processCheckBoxFieldData(objData);
                                    break;
    
                                    case 'EmployeeNoDefault':
                                    case 'Employee':
                                    data[objData.EId || objData.fieldId] = $scope.processEmployeeFieldData(objData);
                                    break;
    
                                    case 'Number':
                                    case 'Amount':
                                    if(objData.value){
                                        numberError = objData.error = objData.numberError = !$scope.hasValidData(objData);
                                    }
                                    data[objData.EId || objData.fieldId] = objData.numberError ? '' : objData.value ;
                                    break;
    
                                    case 'Currency':
                                    if(!$scope.isNullCurrency(objData)){
                                        currencyError = objData.error = objData.numberError = !$scope.hasValidData(objData);
                                    }
                                    data[objData.EId || objData.fieldId] = objData.error ? '' : objData.value;
                                    break;
    
                                    default :
                                    data[objData.EId || objData.fieldId] = objData.value || '';
    
                                }

                                if(numberError || currencyError) {
                                    formIsValid = false;
                                    break;
                                }
                            }
                            if($scope.canEditOffer && angular.isDefined($scope.offerFieldsBackUp) && objData.value !== $scope.offerFieldsBackUp[i][j].value && objData.triggersApproval){
                                    $scope.triggersApproval = true;
                            }
                        }
                    }

                    if(numberError || currencyError) {
                            break;
                    }
                }

                if(!$scope.offer){
                    $scope.offer = {};
                }
                $scope.offer.error = numberError || currencyError || requiredFieldError;
                return formIsValid && data;
            };

            $scope.saveForm = function(){
                $scope.disableSaveButton = true;
                $scope.disableNextButton = true;

                if($scope.offer.submitEnabled){
                    var data =$scope.processApprovalForm($scope.offer.candOfferViewFields);
                    if($scope.offer.multipleOfferFormsEnabled){
                        data.triggersApproval = $scope.triggersApproval;
                    }
                    if(data){
                        $scope.offer.error = false;
                        var offer = {
                            id: $scope.offer.selectedOffer.eid,
                            multipleOfferFormsEnabled: $scope.offer.multipleOfferFormsEnabled
                        };
                        candidates.postCandOfferForm($routeParams.applicationId, $routeParams.stateId, offer, $scope.serializeObject(data), function(res){
                            if(res.msgInfo === 200){
                                $scope.showMsg('OFFER_FORM_SAVED');
                                $scope.flags.loading=true;

                                if($routeParams.mId){
                                    jvHireUrlService.loadCandidateDetailsTabByLink('workflow-offerApprovers/'+$routeParams.applicationId+'/'+$routeParams.stateId+'/'+$routeParams.mId);
                                }else{
                                    jvHireUrlService.loadCandidateDetailsTabByLink('workflow-offerApprovers/'+$routeParams.applicationId+'/'+$routeParams.stateId);
                                }
                                $scope.getSelectApproverMessage(data.triggersApproval);
                            }else if(res.msgInfo === 100){
                                $scope.showMsg('OFFER_APPROVED');
                                $scope.updateWorkflowActions();
                                jvHireUrlService.loadCandidateDetailsTab('workflow',$routeParams.applicationId);
                            }
                        });
                    }else{
                        $scope.disableSaveButton = false;
                        $scope.disableNextButton = false;
                    }
                }else{
                    $scope.modal.show = true;
                    $scope.modal.title = i18n['INSUFFICIENT_PRIVILLEGES_SUBMITOFFER_HEAD'];
                    $scope.modal.body = i18n['INSUFFICIENT_PRIVILLEGES_SUBMITOFFER_MSG'];
                    $scope.modal.buttons=[];
                    $scope.modal.ok = function() {
                        $scope.modal.show = false;
                        jvHireUrlService.loadCandidateDetailsTab('workflow',$routeParams.applicationId);
                    };
                    $scope.modal.cancel = function() {
                        $scope.modal.show = false;
                    };
                }
            };

            $scope.getSelectApproverMessage = function(triggersApproval){
                $scope.flags.loading=true;
                var data = {};
                if($routeParams.mId){
                    data.mId = $routeParams.mId;
                    $rootScope.showApprovers = false;
                }else if($scope.editOffer){
                    data.editOffer = $scope.editOffer;
                    $rootScope.showApprovers = false;
                }else{
                    $rootScope.showApprovers = true;
                }
                if(triggersApproval){
                    data.triggersApproval = triggersApproval;
                    $rootScope.showApprovers = true;
                }

                candidates.getSelectApproverMessage($routeParams.applicationId, $.param(data, true), function(res){
                    $scope.flags.loading=false;
                    $rootScope.selectApprovers = res;
                    $scope.selectApprovers.HMerror = false;
                    $scope.selectApprovers.error = false;
                    $scope.selectApprovers.noApproverError = false;
                    $scope.selectPrimaryHM($rootScope.selectApprovers);
                    $scope.selectApproverFunction($rootScope.selectApprovers);
                    massageWatchers($rootScope.selectApprovers.offerApprovalInfo.model);
                    if($scope.selectApprovers.offerApprovalInfo && $scope.selectApprovers.offerApprovalInfo.model && $scope.selectApprovers.offerApprovalInfo.model.offerApprovalInfo){
                        $scope.selectApprovers.offerApprovalInfo.model.offerApprovalInfo.incEvaluation = true;
                    }
                });
            };

            $scope.selectPrimaryHM = function(response){
                var hmList = response.offerApprovalInfo.model.offerApprovalInfo.hiringManagers;
                var hmSelected = false;
                if(hmList && hmList.length > 0){
                    for(var i=0; i<hmList.length; i++){
                        if(hmList[i].selected){
                            response.offerApprovalInfo.model.offerApprovalInfo.selectedHM = hmList[i].key;
                            hmSelected = true;
                            break;
                        }
                    }
                }

                if(!hmSelected && hmList && hmList.length > 0){
                    response.offerApprovalInfo.model.offerApprovalInfo.selectedHM = hmList[0].key;
                }


            };

            var removeSelectedApprover = function(approverList){
                for(var i=0; i<approverList.length; i++){
                    approverList[i].selected = false;
                }
            };

            $scope.selectApproverFunction = function(response){
                var approvers = response.offerApprovalInfo.model.offerApprovalInfo.approvers.approverEntity;
                var approversClone = angular.copy(approvers);

                for(var i=0; i<approversClone.length; i++){
                    if(approversClone[i].repeatCounts > 1){
                        for(var j=1; j<approversClone[i].repeatCounts; j++){
                            removeSelectedApprover(approversClone[i].approvers);
                            approvers.push(angular.copy(approversClone[i]));
                        }
                    }
                }
                for(var x=0; x<approvers.length; x++){
                    var approverList = approvers[x].approvers;
                    for(var y=0; y<approverList.length; y++){
                        if(approverList[y].selected){
                            approvers[x].selectedApprover = approverList[y].key;
                            break;
                        }
                    }
                }
            };

            $scope.sendOfferLetterReq = function(val){
                $scope.flags.loading=true;
                var data = {};
                var obj = {};
                if(val)
                {
                    var model = $scope.selectApprovers.offerApprovalInfo.model;
                    data = {
                        includeResume       : model.offerApprovalInfo.incResume || false,
                        skipApprovalProcess : false,
                        forwardEvaluations  : model.offerApprovalInfo.incEvaluation || false,
                        messageDataItem: {
                            subject: model.offerApprovalInfo.approvalTemplate.subject,
                            content: model.offerApprovalInfo.approvalTemplate.body,
                            locale: model.offerApprovalInfo.approvalTemplate.locale,
                            attachmentList: []
                        },
                        approverList: [],
                        watchers: [],
                        triggersApproval: model.triggersApproval,
                        editOffer: model.editOffer
                    };

                    if(model.offerApprovalInfo.messageId){
                        data.messageId = model.offerApprovalInfo.messageId;
                    }

                    if(!model.offerApprovalInfo.selectedHM && model.offerApprovalInfo.showPrimaryHiringManagerSelect){
                        $scope.selectApprovers.HMerror = true;
                        $scope.flags.loading = false;
                        return false;
                    }

                    $scope.selectApprovers.error = false;

                    if($scope.selectApprovers.offerApprovalInfo.model.watchUsers) {
                        for(var j=0; j<$scope.selectApprovers.offerApprovalInfo.model.watchUsers.length; j++){
                            obj = {
                                eid: $scope.selectApprovers.offerApprovalInfo.model.watchUsers[j].EId
                            };
                            data.watchers.push(obj);
                        }
                    }

                    for(var i=0; i<model.offerApprovalInfo.approvers.approverEntity.length; i++){
                        obj = model.offerApprovalInfo.approvers.approverEntity[i];
                        var appData = {};
                        if(obj.selectedApprover){
                            appData = {
                                'approvers': [{key: obj.selectedApprover}],
                                'canEdit' : obj.canEdit
                            };
                            data.approverList.push(appData);
                        }
                        else if(obj.approvers.length === 1 && obj.isRequired){
                            appData = {
                                'approvers': [{key: obj.approvers[0].key}],
                                'canEdit' : obj.canEdit
                            };
                            data.approverList.push(appData);
                        }
                        else{
                            if(obj.isRequired){
                                obj.showError = true;
                                $scope.selectApprovers.error = true;
                                $scope.flags.loading=false;
                            }
                        }
                    }

                    if($scope.selectApprovers.error){
                        return false;
                    }

                    if(data.approverList.length === 0){
                        $scope.selectApprovers.noApproverError = true;
                        $scope.flags.loading=false;
                        return false;
                    }
                    for(var x in $scope.attachments){
                        data.messageDataItem.attachmentList.push(x);
                    }
                }
                else
                {
                    data = {
                        skipApprovalProcess : true
                    };
                }
                
               candidates.sendOfferLetterReq($routeParams.applicationId, data, function(res){
                    if(res.msgInfo === 200 || res.msgInfo === 0){
                     if(res.isRestrictedWorkflowState){
                          $rootScope.$broadcast('showRestrictedCandidateModal');
                     }
                    else{
                        $scope.getApplicationDetails(true);
                        $scope.getWorkflowSummary(0);
                        jvHireUrlService.loadCandidateDetailsTab('workflow',$routeParams.applicationId);
                        if(val){
                            $scope.showMsg('OFFER_LETTER_SENT_TO_APPROVERS');
                        }else{
                            $scope.showMsg('OFFER_LETTER_SKIP_APPROVERS');
                        }
                      }
                    }
                    $scope.flags.loading=false;
                });
            };
    }
]);